import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ImagePopupComponent } from '../image-popup/image-popup.component';
@Component({
  selector: 'app-mini-image',
  templateUrl: './mini-image.component.html',
  styleUrls: ['./mini-image.component.scss']
})
export class MiniImageComponent implements OnInit {
  constructor(public dialog: MatDialog) { }
  imgURL = environment.img_url;
  @Input() imgPath: string; 
  ngOnInit(): void {
  }

  openImagePopup(){
    const dialogRef = this.dialog.open(ImagePopupComponent, {
      width: '60vw',
      data:{
        imgPath:this.imgURL + this.imgPath
      }
    })
  }

}
